import { FunctionComponent, SVGProps } from 'react';
import { ReactComponent as IncomeGoalBadge } from '../assets/icons/income-goal-badge.svg';
import { ReactComponent as RetirementGoalBadge } from '../assets/icons/retirement-goal-badge.svg';
import { ReactComponent as WealthGoalBadge } from '../assets/icons/wealth-goal-badge.svg';

const GOAL_TYPE_BADGES: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
    income: IncomeGoalBadge,
    retirement: RetirementGoalBadge,
    wealth: WealthGoalBadge
};

export const getGoalTypeBadge = (type?: string) => (type ? GOAL_TYPE_BADGES[type] : undefined);
